import { ResourceDetailYearly } from './ResourceDetail'

export interface RDProductAppliedPerPlan extends ResourceDetailYearly {
  traitId: 'productAppliedPerPlan'
  result: ProductAppliedOptions
}

export const PRODUCT_APPLIED_OPTIONS = ['fieldWithInset', 'entireField', 'no'] as const
export type ProductAppliedOptions = typeof PRODUCT_APPLIED_OPTIONS[number]
